import { render, staticRenderFns } from "./cModalPrice.vue?vue&type=template&id=e80176fa&scoped=true"
import script from "./cModalPrice.vue?vue&type=script&lang=js"
export * from "./cModalPrice.vue?vue&type=script&lang=js"
import style0 from "./cModalPrice.vue?vue&type=style&index=0&id=e80176fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80176fa",
  null
  
)

export default component.exports